module.exports = __webpack_public_path__ + "static/media/now-logo.ac1549cf.png";